import { ROOT_GLOBAL } from "../global/root";
import { LocalStorage } from "../models/LocalStorage";
import { isMobile } from "./utils";

export const MENU_ID = {
    ORDER_TRACKING: "tracking_order",
    CONTACT: "contact",
    FAQS: "faqs",
    BLOGS: "blogs",
    CAREER: "carreer",
    TERM_OF_USE: "term_of_use",
    COLLABORATOR: "collaborator",
    ORDER_HISTORY: "my_order",
    ADDRESS_BOOK: "address_book",
    NOTIFICATION: "notification",
    LOGOUT: "logout",
    HOW_IT_WORK: "how_it_work",
    SAVED_PAYMENT: "saved_payment",
    MERCHANT_MANAGEMENT: "merchant_management",
}

export const SUBMENU_TERM_OF_USE = [
    {
        id: "termofuse",
        label: "footer_termofuse",
        href: ROOT_GLOBAL.TERM_OF_USE + "#term",
        hash: "term",
        isRedirect: true,
        closeMenu: true,
        country: "VN",
        isHide: () => {
            return LocalStorage.getShipping() !== "VN";
        }
    },
    {
        id: "termsOfService",
        label: "footer_termsOfService",
        href: ROOT_GLOBAL.TERM_OF_USE + "#terms-of-service",
        hash: "terms-of-service",
        isRedirect: true,
        closeMenu: true,
    },
    {
        id: "apiTermofuse",
        label: "footer_apitermofuse",
        href: ROOT_GLOBAL.TERM_OF_USE + "#api-term",
        hash: "api-term",
        isRedirect: true,
        closeMenu: true,
        isHide: () => {
            return LocalStorage.getShipping() === "VN";
        }
    },
    {
        id: "privacyPolicy",
        label: "footer_privacyPolicy",
        href: ROOT_GLOBAL.TERM_OF_USE + "#privacy-policy",
        hash: "privacy-policy",
        isRedirect: true,
        closeMenu: true,
    },
    {
        id: "paymentPolicy",
        label: "footer_paymentPolicy",
        href: ROOT_GLOBAL.TERM_OF_USE + "#payment-policy",
        hash: "payment-policy",
        isRedirect: true,
        closeMenu: true,
        country: "VN",
        isHide: () => {
            return LocalStorage.getShipping() !== "VN";
        }
    },
    {
        id: "shippingPolicy",
        label: "footer_shippingPolicy",
        href: ROOT_GLOBAL.TERM_OF_USE + "#shipping-policy",
        hash: "shipping-policy",
        isRedirect: true,
        closeMenu: true,
        country: "VN",
        isHide: () => {
            return LocalStorage.getShipping() !== "VN";
        }
    },
    {
        id: "refundPolicy",
        label: "footer_refundPolicy",
        href: ROOT_GLOBAL.TERM_OF_USE + "#refund-policy",
        hash: "refund-policy",
        isRedirect: true,
        closeMenu: true,
        country: "VN",
        isHide: () => {
            return LocalStorage.getShipping() !== "VN";
        }
    },
    {
        id: "complaintPolicy",
        label: "footer_complaintPolicy",
        href: ROOT_GLOBAL.TERM_OF_USE + "#complaints-policy",
        hash: "complaints-policy",
        isRedirect: true,
        closeMenu: true,
        country: "VN",
        isHide: () => {
            return LocalStorage.getShipping() !== "VN";
        }
    },
    {
        id: "warrantyPolicy",
        label: "footer_warrantyPolicy",
        href: ROOT_GLOBAL.TERM_OF_USE + "#warranty-policy",
        hash: "warranty-policy",
        isRedirect: true,
        closeMenu: true,
        country: "VN",
        isHide: () => {
            return LocalStorage.getShipping() !== "VN";
        }
    },
    {
        id: "merchantTerm",
        label: "footer_merchantPolicy",
        href: ROOT_GLOBAL.TERM_OF_USE + "#merchant",
        hash: "merchant",
        isRedirect: true,
        closeMenu: true,
        lang: "en",
        isHide: () => {
            return LocalStorage.getShipping() === "VN" || LocalStorage.getLanguage() !== "en";
        }
    },
]

export const MENU_DESKTOP_USER = [
    {
        id: MENU_ID.ORDER_HISTORY,
        label: "menu_orderHistory",
        icon: require("../assets/images/menu/Order_History.svg"),
        iconHover: require("../assets/images/menu/Order_History_Hover.svg"),
        href: ROOT_GLOBAL.ORDER_HISTORY,
        isRedirect: true
    },
    {
        id: MENU_ID.ADDRESS_BOOK,
        label: "menu_addressBook",
        icon: require("../assets/images/menu/Address_Book.svg"),
        iconHover: require("../assets/images/menu/Address_Book_Hover.svg"),
        href: ROOT_GLOBAL.ADDRESS_BOOK,
        isRedirect: true
    },
    {
        id: MENU_ID.COLLABORATOR,
        label: "menu_collaborator",
        icon: require("../assets/images/menu/Collaborator.svg"),
        iconHover: require("../assets/images/menu/Collaborator_Hover.svg"),
        href: ROOT_GLOBAL.COLLABORATOR_DASHBOARD,
        isRedirect: true,
        requireLogin: true,
        className: "collaborator",
        country: "VN",
    },
    {
        id: MENU_ID.MERCHANT_MANAGEMENT,
        label: "menu_merchantManagement",
        icon: require("../assets/images/menu/Partner.svg"),
        iconHover: require("../assets/images/menu/Partner_Hover.svg"),
        href: ROOT_GLOBAL.MERCHANT_MANAGEMENT,
        isRedirect: true
    },
    {
        id: MENU_ID.LOGOUT,
        label: "homepage_logout",
        icon: require("../assets/images/menu/Logout.svg"),
        iconHover: require("../assets/images/menu/Logout_Hover.svg"),
        onClick: () => {
            LocalStorage.logout(ROOT_GLOBAL.HOME_PAGE);
        }
    },
]


export const MENU_DESKTOP_NORMAL = [
    {
        id: MENU_ID.HOW_IT_WORK,
        label: "homepage_howItWork",
        icon: require("../assets/images/menu/HowItWork.svg"),
        iconHover: require("../assets/images/menu/HowItWork_Hover.svg"),
        href: ROOT_GLOBAL.HOW_IT_WORKS,
        isRedirect: true,
    },
    {
        id: MENU_ID.BLOGS,
        label: "menu_blog",
        icon: require("../assets/images/menu/Blog.svg"),
        iconHover: require("../assets/images/menu/Blog_Hover.svg"),
        href: ROOT_GLOBAL.BLOGS,
        isRedirect: true,
        isDofollow: true,
    },
    {
        id: MENU_ID.FAQS,
        label: "menu_faqs",
        icon: require("../assets/images/menu/FAQ.svg"),
        iconHover: require("../assets/images/menu/FAQ_Hover.svg"),
        href: ROOT_GLOBAL.FAQS,
        isRedirect: true,
    },
    {
        id: MENU_ID.CONTACT,
        label: "menu_contact",
        icon: require("../assets/images/menu/ContactUs.svg"),
        iconHover: require("../assets/images/menu/ContactUs_Hover.svg"),
        href: ROOT_GLOBAL.CONTACT,
        isRedirect: true,
    },
    {
        id: MENU_ID.COLLABORATOR,
        label: "menu_becomeCollaborator",
        icon: require("../assets/images/menu/Partner.svg"),
        iconHover: require("../assets/images/menu/Partner_Hover.svg"),
        href: ROOT_GLOBAL.CTV,
        isRedirect: true,
        country: "VN",
    },
    {
        id: MENU_ID.ORDER_TRACKING,
        label: "menu_trackOrder",
        icon: require("../assets/images/menu/TrackOrder.svg"),
        iconHover: require("../assets/images/menu/TrackOrder_Hover.svg"),
        href: ROOT_GLOBAL.ORDER_TRACKING,
        isRedirect: true,
    },
]

export const MENU_MOBILE_USER = [
    {
        id: MENU_ID.ORDER_HISTORY,
        label: "menu_orderHistory",
        href: ROOT_GLOBAL.ORDER_HISTORY,
        isRedirect: true,
        requireLogin: true,
    },
    {
        id: MENU_ID.ADDRESS_BOOK,
        label: "menu_addressBook",
        href: ROOT_GLOBAL.ADDRESS_BOOK,
        isRedirect: true,
        requireLogin: true,
    },
    {
        id: MENU_ID.MERCHANT_MANAGEMENT,
        label: "menu_merchantManagement",
        href: ROOT_GLOBAL.MERCHANT_MANAGEMENT,
        isRedirect: true,
        requireLogin: true,
    },
    {
        id: MENU_ID.SAVED_PAYMENT,
        label: "menu_savedPayment",
        isComingSoon: true,
        requireLogin: true,
    },
    {
        label: "collaborator_products",
        href: ROOT_GLOBAL.COLLABORATOR_PRODUCT,
        hide: true,
    },
    {
        label: "collaboratorProfile_collaboratorProfile",
        href: ROOT_GLOBAL.COLLABORATOR_PROFILE,
        hide: true,
    },
    {
        label: "collaborator_dashboard",
        href: ROOT_GLOBAL.COLLABORATOR_DASHBOARD,
        hide: true,
    },
    {
        id: MENU_ID.COLLABORATOR,
        label: "menu_collaborator",
        href: ROOT_GLOBAL.COLLABORATOR_DASHBOARD,
        isRedirect: true,
        requireLogin: true,
        className: "collaborator",
        country: "VN",
    },
    {
        id: MENU_ID.NOTIFICATION,
        label: "menu_notification",
        href: ROOT_GLOBAL.NOTIFICATIONS,
        isRedirect: true,
        className: " last"
    },
]

export const MENU_MOBILE_NORMAL = [
    {
        id: MENU_ID.ORDER_TRACKING,
        label: "menu_trackOrder",
        href: ROOT_GLOBAL.ORDER_TRACKING,
        isRedirect: true
    },
    {
        id: MENU_ID.CONTACT,
        label: "menu_contact",
        href: ROOT_GLOBAL.CONTACT,
        isRedirect: true
    },
    {
        id: MENU_ID.BLOGS,
        label: "menu_blog",
        href: ROOT_GLOBAL.BLOGS,
        isRedirect: true,
        isDofollow: true
    },
    {
        id: MENU_ID.FAQS,
        label: "menu_faqs",
        href: ROOT_GLOBAL.FAQS,
        isRedirect: true
    },
    {
        id: MENU_ID.CAREER,
        label: "menu_career",
        href: ROOT_GLOBAL.CAREER,
        isRedirect: true,
        country: "VN",
    },
    {
        id: MENU_ID.COLLABORATOR,
        label: "menu_becomeCollaborator",
        href: ROOT_GLOBAL.CTV,
        isRedirect: true,
        country: "VN",
        className: "none-collaborator",
    },
    {
        id: MENU_ID.TERM_OF_USE,
        label: "menu_termofuse",
        subMenu: SUBMENU_TERM_OF_USE
    },
    {
        label: "footer_termofuse",
        href: ROOT_GLOBAL.TERM_OF_USE,
        hide: true
    },
    {
        label: "menu_availableStores",
        href: ROOT_GLOBAL.AVAILABLE_STORES,
        hide: true
    },
    {
        label: isMobile() ? "menu_payment" : "",
        href: ROOT_GLOBAL.PAYMENT,
        hide: true
    },
    {
        label: "menu_becomeCollaborator",
        href: ROOT_GLOBAL.CTV_REGISTER,
        hide: true,
        country: "VN",
    },
    {
        label: "menu_orderDetails",
        href: ROOT_GLOBAL.ORDER_DETAIL,
        hide: true
    },
    {
        label: "menu_summary",
        href: ROOT_GLOBAL.SUMMARY,
        hide: true
    },
    {
        label: "menu_summary",
        href: ROOT_GLOBAL.THANKYOU,
        hide: true
    },
    {
        label: "checkout_secureCheckout",
        href: ROOT_GLOBAL.CHECKOUT,
        hide: true
    },
    {
        label: "menu_yourOrder",
        href: ROOT_GLOBAL.ORDER,
        hide: true
    },
    {
        label: "menu_error",
        href: ROOT_GLOBAL.ERROR_PAGE,
        hide: true
    },
    {
        label: "shortLink_createShortUrl",
        href: ROOT_GLOBAL.SHORT_LINK,
        hide: true
    },
    {
        label: "productDetail_productDetails",
        regex: /-p*[0-9]*.html$/,
        hide: true
    },
    {
        label: "menu_blog",
        regex: /-b*[0-9]*.html$/,
        hide: true
    },
]

export const MENU_ACCOUNT = [
    {
        id: MENU_ID.ADDRESS_BOOK,
        label: "addressBook_addressBook",
        icon: require("../assets/images/menu/Address_Book.svg"),
        href: ROOT_GLOBAL.ADDRESS_BOOK,
        isActive: window.location.pathname.includes(ROOT_GLOBAL.ADDRESS_BOOK),
    },
    // {
    //     id: MENU_ID.MERCHANT_MANAGEMENT,
    //     label: "merchantAccount_merchantManagement",
    //     icon: require("../assets/images/menu/Merchant.svg"),
    //     href: ROOT_GLOBAL.MERCHANT_MANAGEMENT,
    //     isActive: window.location.pathname.includes(ROOT_GLOBAL.MERCHANT_MANAGEMENT),
    // },
]